module.exports = __webpack_public_path__ + "static/media/34.11912dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/34.png
// module id = 402
// module chunks = 0